import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
interface MobileSortModalProps {
  isOpen: boolean;
  onClose: () => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
}
export function MobileSortModal({
  isOpen,
  onClose,
  sortBy,
  onSortChange
}: MobileSortModalProps) {
  const sortOptions = [{
    label: 'Best Match',
    value: 'best-match'
  }, {
    label: 'Top Rated',
    value: 'top-rated'
  }, {
    label: 'Price: Low to High',
    value: 'price-low-high'
  }, {
    label: 'Price: High to Low',
    value: 'price-high-low'
  }];
  const handleSortChange = (value: string) => {
    onSortChange(value);
    onClose();
  };
  if (!isOpen) return null;
  return <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[200]" onClick={onClose} data-id="element-1725" data-mp="105xayb8gvih9" />
      {/* Bottom Sheet */}
      <div className="fixed bottom-0 left-0 right-0 bg-white z-[201] rounded-t-2xl shadow-xl max-h-[80vh] overflow-y-auto" data-id="element-1726" data-mp="2uhbziopqrbvf">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-1727" data-mp="20clmfex6744h">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-1728" data-mp="1qcl0dl7x29wl">Sort By</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100" data-id="element-1729" data-mp="1qefn952r0c3b">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-1730" data-mp="2j109jr4d9y00" />
          </button>
        </div>
        {/* Sort Options */}
        <div className="p-4" data-id="element-1731" data-mp="2o0mpw9fhrud1">
          <div className="space-y-1" data-id="element-1732" data-mp="2nys46sweby7w">
            {sortOptions.map(option => <button key={option.value} onClick={() => handleSortChange(option.value)} className={`w-full flex items-center justify-between py-3 px-4 rounded-lg transition-colors ${sortBy === option.value ? 'bg-blue-50 text-[#0066CC]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1733" data-mp="29byty21qhimk">
                <span className="text-sm font-medium" data-id="element-1734" data-mp="36rw2wsoh119d">{option.label}</span>
                {sortBy === option.value && <CheckIcon className="w-5 h-5 text-[#0066CC]" data-id="element-1735" data-mp="3bngugergstuf" />}
              </button>)}
          </div>
        </div>
      </div>
    </>;
}